import { render, staticRenderFns } from "./Boardal.vue?vue&type=template&id=2a5c83f1&scoped=true"
import script from "./Boardal.vue?vue&type=script&lang=js"
export * from "./Boardal.vue?vue&type=script&lang=js"
import style0 from "./Boardal.vue?vue&type=style&index=0&id=2a5c83f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c83f1",
  null
  
)

export default component.exports